import { useFormContext } from 'react-hook-form';

import { Box } from '@mui/material';
import { useQueryGetReferenceTemplates } from 'features/References/api';
import auth from 'utils/auth';
import { SharedQuestionAndAnswerSection } from 'sharedComponents/Questions/components/SharedQuestionAndAnswerSection';
import { ATSConnectHiringRequestRequestReferenceTestIds } from 'data-testids/ATS';
import { useGetCumulativeScore } from 'features/Connect/features/ConnectATSIntegration/utils';

export const WriteReferenceCheck = () => {
  const { watch } = useFormContext();
  const districtId = auth.getUser()?.district?.id;
  const updateCumulativeScore = useGetCumulativeScore();

  const { data: referenceTemplates } = useQueryGetReferenceTemplates(districtId);

  const referenceTemplateId = watch('reference_template_id');
  const selectedTemplate = referenceTemplates?.find(
    (template) => template.id === referenceTemplateId
  );

  return (
    <>
      {selectedTemplate?.questions.map((question, index) => (
        <Box sx={{ pt: 3 }} key={question.id}>
          <SharedQuestionAndAnswerSection
            index={index}
            question={question}
            onCumulativeScoreUpdate={updateCumulativeScore}
            testIdPrefix={ATSConnectHiringRequestRequestReferenceTestIds.REFERENCE_QUESTION}
          />
        </Box>
      ))}
    </>
  );
};
